import React ,{useEffect, useState} from 'react';
import { loadCancelledRXDetails,  } from '../../Services/loadOrder';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuBar from './MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import "../../assets/css/home.css";
import toast, {Toaster} from 'react-hot-toast';

const CanceledDetails = () => {
    const { state } = useLocation();
    const { taskId,
          contract,
          pharmacyId,
          userId,
          memberId,
            authNo,
        source} = state || {};
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    


    const columns = [{ field: 'From', headerName: 'From', flex:2.8, headerClassName: 'pink-header' },
    { field: 'To', headerName: 'To', flex:2.8, headerClassName: 'pink-header' },
    { field: 'AuthNo', headerName: 'Auth No', flex:2.8, headerClassName: 'pink-header' },
    { field: 'OR', headerName: 'O/R', flex:1, headerClassName: 'pink-header' },
    { field:'NDC', headerName: 'NDC', flex:2, headerClassName: 'pink-header' },
    { field: 'DrugName', headerName: 'Drug Name', flex:2, headerClassName: 'pink-header',
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },  
    { field: 'GpiName', headerName:'GPI Name',flex:2, headerClassName: 'pink-header',
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.9,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
    { field: 'Qty', headerName: 'QTY', flex:2, headerClassName: 'pink-header' },
    { field: 'Reason', headerName: 'Reason',flex:2.6, headerClassName: 'pink-header' },
       
];
    const [loading, setLoading] = useState(true); 
    useEffect(() =>{
        const fetchData = async () => {
  const user = JSON.parse(localStorage.getItem('user'));
  //const pharmacyId = user?.pharmacyId;
 // const userId = user?.userId;
  if (!pharmacyId) return;

  const orderResponse = await loadCancelledRXDetails(pharmacyId, memberId, authNo, taskId, contract);
if (orderResponse.success) {
  const taskDetails = orderResponse?.data || [];
  console.log("Raw order response:", orderResponse);
console.log("TaskDetails:", orderResponse?.data);


  const formattedRows = taskDetails.map((item, index) => ({
    id: index + 1,
    From: item.From ? new Date(item.From).toLocaleDateString() : '',
    To: item.To ? new Date(item.To).toLocaleDateString() : '',
    AuthNo: item.AuthNo,
    OR: item?.['O/R'],
NDC: item.NDC, // Optional field
    GpiName: item.GPIName,
    Qty: item.Qty,
    Reason: item.Reason,
    taskId: item.TaskID,
    pharmacyId,
    userId,
    CancelledBy: item.CancelledBy,
  }));

  console.log("Formatted rows:", formattedRows);
  setRows(formattedRows);
} else {
  toast.error("No TaskDetails found.");
}


  setLoading(false);
};

        fetchData();
    },[]);



    // Render all labels/UI first, then overlay spinner if loading
    return (
        <div>
            <MenuBar/>
            <Toaster position='top-right'/>
            <div className='top-page-option'>
                <div 
                    onClick={() => navigate(source === 'partial' ? '/partially-cancelled-grid' : '/entirelly-cancelled-grid')}
                    style={{
                        cursor: 'pointer',
                        textDecoration: 'none',
                        color: '#ec088c',
                        display: 'inline-flex',
                        alignItems: 'center'
                    }}
                >
                    <ChevronLeft color='#ec088c' size={18} />
                    <span style={{ marginLeft: '5px', fontSize: '20px' }}>Back</span>
                </div>
                <div className='top-page-option-name'>
                    Cancelled Orders
                    <ChevronRight color='#ec088c' size={18} />
                    {source === 'partial' ? 'Partially Cancelled Order' : 'Entirely Cancelled Order'}
                    <ChevronRight color='#ec088c' size={18} />
                    Cancelled Details
                </div>
            </div>
            <div style={{ height: 'auto', width: '87%', margin: 'auto' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[10, 25, 50]}
                    disableSelectionOnClick
                    sx={{
                        fontSize: '12px',
                        fontFamily: 'Segoe UI',
                        '& .pink-header': {
                            color: '#fff',
                            backgroundColor: '#ec008c',
                            fontWeight: 'bold',
                            whiteSpace: 'normal !important',
                            wordBreak: 'breakWord !important',
                            overflowWrap: 'breakWord !important',
                            lineHeight: '1.3 !important',
                            textAlign: 'center',
                            padding: '8px 2px !important',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#f5f5f5 !important',
                            cursor: 'pointer',
                        },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                            outline: 'none !important',
                            boxShadow: 'none !important',
                            backgroundColor: 'none !important',
                        },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none !important',
                            boxShadow: 'none !important',
                        },
                    }}
                />
            </div>
            {loading && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(255,255,255,0.7)', zIndex: 2000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #EC088C', borderRadius: '50%', width: 48, height: 48, animation: 'spin 1s linear infinite' }} />
                    <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
                    <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
                </div>
            )}
        </div>
    );
};

export default CanceledDetails;